module.exports = __webpack_public_path__ + "static/media/poweroffActive.0a261371.png";